import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onDragStart = new EventEmitter();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onDrag = new EventEmitter();
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onDragEnd = new EventEmitter();
  @Output() dragging = new EventEmitter();

  @Output() startChanged = new EventEmitter();
  @Output() endChanged = new EventEmitter();

  @Output() cardStartTimeDragStart = new EventEmitter();
  @Output() cardStartTimeDragged = new EventEmitter();

  @Output() cardEndTimeDragStart = new EventEmitter();
  @Output() cardEndTimeDragged = new EventEmitter();

  @Input() route: any;

  ngOnInit() {
    console.log('route', this.route);
  }

  cardDragStart(event) {
    this.onDragStart.emit({ id: this.route.id, event });
  }

  cardDragged(event) {
    event.stopPropagation();
    event.preventDefault();
    this.onDrag.emit({ id: this.route.id, event });
  }

  cardDragEnd(event) {
    // event.stopPropagation();
    // event.preventDefault();
    this.onDragEnd.emit({ id: this.route.id, event });
  }

  isDragging(event) {
    this.dragging.emit({ id: this.route.id, event });
  }

  startTimeChanged(event) {
    // event.stopPropagation();
    // event.preventDefault();
    this.startChanged.emit({ id: this.route.id, time: event });
  }

  endTimeChanged(event) {
    // event.stopPropagation();
    // event.preventDefault();
    this.endChanged.emit({ id: this.route.id, time: event });
  }

  cardStartDragStart(event) {
    event.stopPropagation();
    this.cardStartTimeDragStart.emit({ id: this.route.id, event });
  }

  cardStartDrag(event) {
    this.cardStartTimeDragged.emit({ id: this.route.id, event });
    event.stopPropagation();
    // event.preventDefault();
  }

  cardEndDragStart(event) {
    event.stopPropagation();
    this.cardEndTimeDragStart.emit({ id: this.route.id, event });
  }

  cardEndDrag(event) {
    this.cardEndTimeDragged.emit({ id: this.route.id, event });
    event.stopPropagation();
    event.preventDefault();
  }

  getStyle(id: string) {
    return {
      left: `calc(var(--interval-width) * var(--${id}-interval-offset))`,
      width: `calc(var(--interval-width) * var(--${id}-interval-width))`
    };
  }
}
